import { render, staticRenderFns } from "./MediaContainer.vue?vue&type=template&id=65354e73&"
import script from "./MediaContainer.vue?vue&type=script&lang=js&"
export * from "./MediaContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports